<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  modelValue: { type: String, default: '' },
  fieldErrors: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();
</script>

<template>
  <div class="space-y-2">
    <div class="flex items-center justify-between">
      <label class="text-xs font-medium text-n-slate-11">
        {{ t('INBOX_MGMT.TEMPLATES.CREATE.FOOTER') }}
      </label>
      <span
        class="text-[11px]"
        :class="modelValue.length > 55 ? 'text-n-ruby-9' : 'text-n-slate-10'"
      >
        {{ modelValue.length }}/60
      </span>
    </div>
    <input
      :value="modelValue"
      type="text"
      maxlength="60"
      class="w-full h-9 px-3 rounded-lg outline outline-1 outline-n-weak bg-transparent text-sm text-n-slate-12 focus:outline-n-brand"
      :placeholder="t('INBOX_MGMT.TEMPLATES.CREATE.FOOTER_PH')"
      @input="emit('update:modelValue', $event.target.value)"
    />
    <p v-if="fieldErrors.footer" class="text-[11px] text-n-ruby-9">
      {{ fieldErrors.footer }}
    </p>
  </div>
</template>
